//@ts-check
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { LoadingContractsComponent } from '../components/loading-contracts-component';
import { getContractsAction } from '../redux/actions/contract-actions';
import { PromiseePartiesComponent } from '../components/promisee-parties-components';
import { CreateContractComponent } from '../components/create-contract-component';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  list: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0)
  },
  heading: {
    margin: theme.spacing(2)
  }
}));

export function ContractsPage({ client }) {
  const classes = useStyles();

  const { contracts, loading } = useSelector((state) => state.contracts);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getContractsAction(client.id));
  }, [dispatch, client.id]);

  return (
    <>
      {loading && <LoadingContractsComponent />}
      {!loading && (
        <>
          <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
            <small>
              <b>Contracts</b>
              <br />
              Contracted Promisee Parties
            </small>
          </Typography>
          <CreateContractComponent client_id={client.id} />
          <PromiseePartiesComponent contracts={contracts} />
        </>
      )}
    </>
  );
}
